module.exports = __webpack_public_path__ + "img/1.dcc69ddc.png";